var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonLinkRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17.001 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144544",
  fill: "none",
  d: "M.001 0h17v16h-17z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.487 8.84H.834a.807.807 0 01-.595-.24.807.807 0 01-.24-.595.808.808 0 01.24-.595.808.808 0 01.595-.24h12.653L7.738 1.421A.784.784 0 017.493.84a.826.826 0 01.262-.591.871.871 0 01.586-.25.778.778 0 01.586.25L15.978 7.3a.922.922 0 01.22.329 1.069 1.069 0 01.064.374 1.069 1.069 0 01-.064.374.923.923 0 01-.22.329l-7.051 7.051a.8.8 0 01-.572.236.831.831 0 01-.6-.236.817.817 0 01-.259-.595.817.817 0 01.259-.594z",
  fill: "#29398c"
})));
export default __webpack_public_path__ + "static/ButtonLinkRightArrow.e627d3e6fdb7e938afc82f30b68eb73e.svg";
export { SvgButtonLinkRightArrow as ReactComponent };